import React, { useEffect, useMemo } from "react";
import { Card, CardBody, CardGroup, Col, Container, Row } from "reactstrap";
import { authenticationReducerActions } from "../../_services/store";
import { logout } from "../services/store/authentication.actions";
import LoginForm from "../../_components/LoginForm";
import styled from "styled-components";
import useEnvironment, { EnvironmentEnum } from "../../EnvironmentUtils";
import { useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getPublicResponseNotification } from "../../notification/store/notification.actions";
import NotificationModal from "../../notification/components/NotificationModal";

const LoginScreen = () => {
    const authentication = useSelector((state) => state.authentication);
    const userRegistration = useSelector((state) => state.userRegistration);
    const dispatch = useDispatch();
    const location = useLocation();

    const redirectUrl = useMemo(() => {
        const queryParameters = new URLSearchParams(location.search);
        return queryParameters.has("redirect_url") ? queryParameters.get("redirect_url") : "/";
    }, [location]);

    useEffect(() => {
        // reset login status
        dispatch(logout());
        dispatch(authenticationReducerActions.clearResetSuccessMessage());
        if (location && location.search && new URLSearchParams(location.search).has("notificationId")) {
            dispatch(getPublicResponseNotification(new URLSearchParams(location.search).get("notificationId")));
        }
    }, [dispatch, location]);

    const { environment, color } = useEnvironment();

    return (
        <div className="app flex-row align-content-center" style={{ height: "100vh", background: "#e4e5e6" }}>
            <NotificationModal />
            <Container>
                <Row className="justify-content-center">
                    <Col md="6" xs="12">
                        <CardGroup>
                            <Card>
                                <CardBody>
                                    {environment === EnvironmentEnum.STAGING ||
                                    environment === EnvironmentEnum.ITEST ? (
                                        <LogoContainer className={color}>
                                            <img
                                                src="/logo.png"
                                                alt="Pathway Logo"
                                                style={{ maxWidth: "60%" }}
                                                className="rounded mx-auto d-block"
                                            />

                                            <br />
                                            <EnvironmentWrapper>{environment}</EnvironmentWrapper>
                                        </LogoContainer>
                                    ) : (
                                        <img
                                            src="/logo.png"
                                            alt="Pathway Logo"
                                            style={{ maxWidth: "60%" }}
                                            className="rounded mx-auto d-block"
                                        />
                                    )}
                                    <br />
                                    <h1>Login</h1>
                                    <br />

                                    <LoginForm
                                        authentication={authentication}
                                        registration={userRegistration}
                                        loginIdentifier="platform"
                                        redirectUrl={redirectUrl}
                                    />
                                </CardBody>
                            </Card>
                        </CardGroup>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default LoginScreen;

const EnvironmentWrapper = styled.div`
    color: white;
    font-weight: bold;
    font-size: 1.5em;
    text-align: center;
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
`;

const LogoContainer = styled.div`
    background-color: ${({ color }) => color};
    padding: 10px;
    border-radius: 5px;
    text-align: center;
    position: relative;
    margin-bottom: 20px;
`;
